module.exports = __webpack_public_path__ + "components/app-promo/static/en/snow-forecast__app-screenshot--4-bff12d082c242058076a2225931479ce.jpg";